import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { WizardProvider } from "./lib/wizardStore";
import Landing from "./pages/Landing";
import Wizard from "./pages/Wizard";
import Completion from "./pages/Completion";

function App() {
  return (
    <WizardProvider>
      <div className="App font-body">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/completion" element={<Completion />} />
          </Routes>
        </BrowserRouter>
      </div>
    </WizardProvider>
  );
}

export default App;
